import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import { Picture } from 'ui-kit/picture'
import { LINKS } from 'routes/constants'
import ImageDiscoverMob1x from './image-discover-mob1x.png'
import ImageDiscoverMob2x from './image-discover-mob2x.png'
import ImageDiscoverDesk1x from './image-discover-desk1x.png'
import ImageDiscoverDesk2x from './image-discover-desk2x.png'
import ImageInteractMob1x from './image-interact-mob1x.png'
import ImageInteractMob2x from './image-interact-mob2x.png'
import ImageInteractDesk1x from './image-interact-desk1x.png'
import ImageInteractDesk2x from './image-interact-desk2x.png'
import ImageUseMob1x from './image-use-mob1x.png'
import ImageUseMob2x from './image-use-mob2x.png'
import ImageUseDesk1x from './image-use-desk1x.png'
import ImageUseDesk2x from './image-use-desk2x.png'
import clsx from 'clsx'
import classes from './DiscoverStructure.module.scss'

export const DiscoverStructure = () => {
  return (
    <Block as={'section'} divider={'mobile'} className={classes.section}>
      <Block
        variant={'solid'}
        className={clsx(classes.section__block, classes.section__top)}
      >
        <Heading
          as={'h2'}
          lh={'tight'}
          balance
          center
          className={classes.title}
        >
          Discover the structure of any external app automatically
        </Heading>
        <div className={classes.section__textWrap}>
          <Text center balance size={'lg'} className={classes.section__text}>
            When your application needs to know what an external application can
            do, how operations, data, and events look like, and how to work with
            them - it can learn all of this from a connector fully
            automatically.
          </Text>
          <Text center balance size={'lg'} className={classes.section__text}>
            This lets you build integration code of any complexity that is
            API-agnostic. You can build integration scenarios, Ul, or whole
            integration platforms on top of universal connectors with zero
            application-specific code.
          </Text>
        </div>
        <div className={clsx(classes.visual, classes.visual__top)}>
          <Picture
            mobSrc1x={ImageDiscoverMob1x.src}
            mobSrc2x={ImageDiscoverMob2x.src}
            deskSrc1x={ImageDiscoverDesk1x.src}
            deskSrc2x={ImageDiscoverDesk2x.src}
            className={classes.image}
            lazyLoad
            alt='Universal Resources'
            width={350}
            height={735}
          />
        </div>
      </Block>
      <Block
        variant={'solid'}
        className={clsx(classes.section__block, classes.section__bottom)}
      >
        <Heading
          as={'h2'}
          lh={'tight'}
          balance
          center
          className={classes.title}
        >
          Interact with operations, data, and events in a consistent way
        </Heading>
        <Text size={'lg'} center balance className={classes.section__text}>
          When you don't care about the structure of a particular app and just
          want to do something consistently across multiple apps, you Universal
          Resources help you achieve it.
        </Text>
        <Text size={'lg'} center balance className={classes.section__text}>
          For example, if you want to read a list of users from any app that has
          users, you can use a corresponding Universal Data Model that
          normalizes user data across all external apps.
        </Text>
        <div className={classes.visual}>
          <Picture
            mobSrc1x={ImageInteractMob1x.src}
            mobSrc2x={ImageInteractMob2x.src}
            deskSrc1x={ImageInteractDesk1x.src}
            deskSrc2x={ImageInteractDesk2x.src}
            className={classes.image}
            lazyLoad
            alt='Interact with operations, data, and events in a consistent way'
            width={350}
            height={454}
          />
        </div>
      </Block>
      <Block
        variant={'solid'}
        className={clsx(classes.section__block, classes.section__bottom)}
      >
        <Heading
          as={'h2'}
          lh={'tight'}
          balance
          center
          className={classes.title}
        >
          Use directly or with Universal Integrations
        </Heading>
        <Text size={'lg'} center balance className={classes.section__text}>
          You can access connector functionality directly to work with
          application resources or even make raw API requests.
        </Text>
        <Text size={'lg'} center balance className={classes.section__text}>
          <Link
            className={classes.link}
            type='noLineGradient'
            href={LINKS.UNIVERSAL_INTEGRATIONS}
          >
            Universal Integrations Framework
          </Link>
          &nbsp; builds on top of universal connectors to quickly implement
          specific integration scenarios and scale them to dozens of apps.
        </Text>
        <div className={classes.visual}>
          <Picture
            mobSrc1x={ImageUseMob1x.src}
            mobSrc2x={ImageUseMob2x.src}
            deskSrc1x={ImageUseDesk1x.src}
            deskSrc2x={ImageUseDesk2x.src}
            className={classes.image}
            lazyLoad
            alt='Use directly or with Universal Integrations'
            width={350}
            height={744}
          />
        </div>
      </Block>
    </Block>
  )
}
